import deepmerge from "deepmerge";
import hasIn from "lodash/hasIn";
import omitBy from "lodash/omitBy";
import pick from "lodash/pick";
import { useCallback, useMemo, useReducer } from "react";
import { useLocalStorage } from "react-use";
import { LOCAL_STORAGE_KEY } from "../constants/localStorage";
import { defaultCachableWalletState, defaultWalletState, EStrategy, EWalletActions, walletReducer, } from "../store";
export const usePersistentReducer = () => {
    const [savedState, saveState, remove] = useLocalStorage(LOCAL_STORAGE_KEY, defaultCachableWalletState);
    const persistentReducer = useCallback((state, action) => {
        const newState = walletReducer(state, action);
        if (action.type === EWalletActions.CLEAR_LOCAL_STORAGE) {
            newState?.dAppConnector?.instance()?.shutdownServer();
            remove();
        }
        // Only cache CIP-30 connections for now.
        if (newState.options.strategy === EStrategy.CIP30) {
            const cachableState = pick(newState, Object.keys(defaultCachableWalletState));
            saveState(cachableState);
        }
        return newState;
    }, [saveState, remove]);
    // Sync up local state with default keys.
    const hydratedState = useMemo(() => {
        const placeholderObject = {
            activeWallet: null,
            details: {
                network: 1,
                mainAddress: "",
                stakingAddress: "",
                unusedAddresses: [],
                usedAddresses: [],
                credentials: {
                    staking: "",
                    payment: "",
                },
                hex: {
                    stakingAddress: "",
                    mainAddress: "",
                },
            },
        };
        const syncedState = deepmerge(placeholderObject, omitBy(savedState, (_value, key) => {
            if (!hasIn(placeholderObject, key)) {
                return true;
            }
            return false;
        }));
        const data = {
            ...defaultWalletState,
            ...syncedState,
            ...(syncedState.details && {
                initialized: {
                    balance: false,
                    details: true,
                },
            }),
        };
        return data;
    }, [defaultWalletState]);
    const reducer = useReducer(persistentReducer, hydratedState);
    return reducer;
};
//# sourceMappingURL=usePersistentReducer.js.map